'use strict';

const methods = ['assert', 'cd', 'clear', 'count', 'countReset',
  'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed',
  'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd',
  'select', 'table', 'time', 'timeEnd', 'timeStamp', 'timeline',
  'timelineEnd', 'trace', 'warn'];

if (!window.console) {
  window.console = {};
  methods.forEach((methodName) => window.console[methodName] = function () {});
}



// WEBPACK FOOTER //
// ./app/src/console_mock.js